<template>
  <div class="digital-container">
    <div class="digital-wrapper">
      <h1>Válassz a lehetőségek közül</h1>
      <div class="digital-card-container">
        <div class="digital-card"
             @click="$modal.show('digital-reservation-start-modal')">
          Van foglalásom
        </div>
        <div class="digital-card"
             @click="$modal.show('digital-reservation-start-modal', { initialState: 'BUY_OTHER_ITEMS' })">
          Vásárlás
        </div>
        <div class="digital-card"
             @click="$router.push('/')">
          Nincs foglalásom
        </div>
      </div>
    </div>
    <div class="digital-footer-text">&mdash; A Foglaljpalyat.hu csapata</div>
    <digital-reservation-start-modal/>
  </div>
</template>

<script>

import DigitalReservationStartModal from '@/components/modal/DigitalReservationStartModal.vue';
// import utils from "@/utils";
// import config from "@/config";

export default {
  components: { DigitalReservationStartModal },
  methods: {},
  computed: {},
  created: function () {
  },
}
</script>

<style scoped>
.digital-container {
  text-align: center;
  height: 100vh;
  width: 100vw;
  font: 20px Helvetica, sans-serif;
  color: #333;
}

.digital-wrapper {
  font: 20px Helvetica, sans-serif;
  color: #333;
  padding: 150px;
  background: url('/static/img/digital-background-v3.jpg') center no-repeat;
  height: 100vh;
}

.digital-wrapper h1 {
  font-size: 50px;
  background: #ffffffc4;
  color: #000;
}

.digital-card-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}

.digital-card {
  margin-top: 1rem;
  width: 300px;
  height: 200px;
  background-color: #f2711ce0;
  text-align: center;
  vertical-align: middle;
  line-height: 200px;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 26px;
  color: black;
}

.digital-card:hover {
  background-color: #f2711c;
}

.digital-footer-text {
  position: absolute;
  bottom: 0;
  color: white;
  width: 100vw;
}
</style>
